module.exports = __webpack_public_path__ + "./images/Servicio.b6f235988efe3517a5b86ece9b6c2965.png";


//////////////////
// WEBPACK FOOTER
// ./websources/public/images/Servicio.png
// module id = ./websources/public/images/Servicio.png
// module chunks = 0